export default __webpack_public_path__ + "static/media/LEVEL3.c26a51bc.png";